export default __webpack_public_path__ + "static/media/affiche2014.9b8ba84a.png";